import React, { useState } from 'react';
import { useForm } from 'react-hook-form';
import { Link } from 'react-router-dom';
import { authAPI } from '../services/api';
import { toast } from 'sonner';
import './Auth.css';

const ForgotPassword = () => {
    const { register, handleSubmit, formState: { errors } } = useForm();
    const [loading, setLoading] = useState(false);
    const [submitted, setSubmitted] = useState(false);

    const onSubmit = async (data) => {
        setLoading(true);
        try {
            await authAPI.forgotPassword(data);
            setSubmitted(true);
            toast.success('Reset link sent to your email!');
        } catch (error) {
            toast.error(error.response?.data?.message || 'Something went wrong');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="login-container">
            <div className="login-left">
                <div className="illustration-section">
                    <img
                        src="https://images.unsplash.com/photo-1552664730-d307ca884978?w=600&h=800&fit=crop"
                        alt="Team collaboration"
                        className="hero-image"
                    />
                    <div className="image-overlay">
                        <h3 className="illustration-title">Account Recovery</h3>
                        <p className="illustration-text">Don't worry, it happens to the best of us. Let's get you back in. </p>
                    </div>
                </div>
            </div>
            <div className="login-right">
                <div className="login-card">
                    <div className="login-header">
                        <div className="login-logo">TM</div>
                        <h2 className="login-title">Forgot Password?</h2>
                        <p className="login-subtitle">
                            {submitted
                                ? "Check your email for the reset link"
                                : "Enter your username to receive a password reset link"}
                        </p>
                    </div>

                    {!submitted ? (
                        <form onSubmit={handleSubmit(onSubmit)} className="login-form">
                            <div className="form-group">
                                <label className="form-label">Username</label>
                                <input
                                    type="text"
                                    {...register('username', { required: 'Username is required' })}
                                    className="form-input"
                                    placeholder="Enter your username"
                                    disabled={loading}
                                />
                                {errors.username && <span className="error-text">{errors.username.message}</span>}
                            </div>

                            <button type="submit" className="login-button" disabled={loading}>
                                {loading ? 'Sending link...' : 'Send Reset Link'}
                            </button>
                        </form>
                    ) : (
                        <div className="success-view">
                            <div className="success-icon">
                                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                    <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path>
                                    <polyline points="22 4 12 14.01 9 11.01"></polyline>
                                </svg>
                            </div>
                            <p className="success-text">
                                An email has been sent to your registered address with instructions to reset your password.
                            </p>
                            <Link to="/login" className="login-button" style={{ textAlign: 'center', textDecoration: 'none', display: 'block' }}>
                                Back to Login
                            </Link>
                        </div>
                    )}

                    <div className="auth-footer">
                        <Link to="/login" className="link">Remembered your password? Sign in</Link>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ForgotPassword;
